import { useEffect, useState } from "react";
import style from "./WeeklyCartVolume.module.css";
import VerticalFlex from "layouts/flex/VerticalFlex";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import CustomIcon from "components/icons/CustomIcon";
import clsx from "classnames";
import P from "components/P";
import { adminRequester, requester } from "App";
import NiceModal from "@ebay/nice-modal-react";

function WeeklyCartVolume() {
  const [user, setUser] = useState();
  const [data, setData] = useState([]);
  const [mounted, setMounted] = useState(false);
  const start_date = new Date();
  start_date.setDate(start_date.getDate() - start_date.getDay());
  const end_date = new Date();
  useEffect(() => {
    setMounted(true);
    adminRequester.getCurrentUser(({ user }) => setUser(user));
  }, []);
  useEffect(() => {
    if (mounted && user) {
      const data = {
        status: "cart",
        start_date: start_date,
        end_date: end_date,
        interval: "week",
        limit: 5,
      };
      if (user.role === "member") {
        data.store_id = user.store_id;
      }
      adminRequester.getStatistic(data, (result) => {
        const data = result.data;

        if (!data || data?.length === 0) {
          setData([
            { product: "-", option: "-", count: null },
            { product: "-", option: "-", count: null },
            { product: "-", option: "-", count: null },
            { product: "-", option: "-", count: null },
            { product: "-", option: "-", count: null },
          ]);
        } else setData(data);
      });
    }
  }, [mounted, user]);

  return (
    <div className={style.container}>
      <VerticalFlex>
        <FlexChild>
          <div className={style.label}>
            <HorizontalFlex gap={10}>
              <FlexChild width={"max-content"}>
                <CustomIcon name={"statisticsCart"} width={20} />
              </FlexChild>
              <FlexChild>
                <P>주간 장바구니 BEST 5</P>
              </FlexChild>
              <FlexChild width={"max-content"}>
                <P
                  hover
                  cursor
                  size={12}
                  onClick={() =>
                    data?.length > 0 &&
                    NiceModal.show("showData", {
                      title: "주간 장바구니 BEST",
                      headers: [
                        { label: "index", Cell: ({ index }) => index + 1 },
                        { label: "상품명", code: "product" },
                        { label: "옵션명", code: "option" },
                        { label: "수량", code: "count" },
                      ],
                      requester: (data, callback) =>
                        adminRequester.getStatistic(
                          {
                            ...data,
                            status: "cart",
                            start_date: start_date,
                            end_date: end_date,
                            interval: "week",
                          },
                          callback
                        ),
                      limit: 20,
                    })
                  }
                >
                  +더보기
                </P>
              </FlexChild>
            </HorizontalFlex>
          </div>
        </FlexChild>
        <FlexChild width={"90%"}>
          <table className={style.table}>
            <thead className={style.thead}>
              <tr>
                <th className={style.th}>순위</th>
                <th className={style.th}>상품명</th>
                <th className={style.th}>옵션명</th>
                <th className={style.th}>수량</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {data &&
                data.map((row, index) => (
                  <tr key={index} className={style.tr}>
                    <td className={style.td}>
                      <div
                        className={clsx(
                          style.tdLabel,
                          index < 3 ? style.specialTdLabel : null
                        )}
                      >
                        {index + 1}
                      </div>
                    </td>
                    <td
                      className={clsx(
                        style.td,
                        index < 3 ? style.specialRank : null
                      )}
                    >
                      {row.product}
                    </td>
                    <td
                      className={clsx(
                        style.td,
                        index < 3 ? style.specialRank : null
                      )}
                    >
                      {row.option}
                    </td>
                    <td
                      className={clsx(
                        style.td,
                        index < 3 ? style.specialRank : null
                      )}
                    >
                      {row.count ? row.count : "-"}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </FlexChild>
      </VerticalFlex>
    </div>
  );
}

export default WeeklyCartVolume;
